import React, {Fragment} from 'react';

import {translations} from 'presentation/translations-new';
import {useQueryParams} from 'presentation/pages';
import {ChatRoomsEnum, FeaturesEnum} from 'presentation/constants';
import {DefaultEmptyState} from 'presentation/components/DefaultEmptyState';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';

import {BookingSearchEmptyStateProps} from './types';
import {FlowEnum} from '../../../constants/flowEnum';

const {noFilteredResults, emptyDescription} = translations['pt-br'].commons;

export function BookingSearchEmptyState({
	flowType,
	dataTagId,
	children,
}: BookingSearchEmptyStateProps) {
	const {
		SEARCH_PARAMS: {query},
		clearSearch,
	} = useQueryParams();
	const {isEnabled: isBookingSearchEmptyStateEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_BOOKING_SPECIALTY_SEARCH_EMPTY_STATE,
	);

	if (!isBookingSearchEmptyStateEnabled || !query) {
		return <Fragment>{children}</Fragment>;
	}

	const chatRoomType = flowType === FlowEnum.ODONTO ? ChatRoomsEnum.ODONTO : ChatRoomsEnum.APP;

	return (
		<DefaultEmptyState
			title={noFilteredResults}
			description={emptyDescription}
			dataTagId={dataTagId}
			clearFilters={clearSearch}
			hasCallChatRoom
			chatRoomType={chatRoomType}
		/>
	);
}
